var map = {
	"./logo-1.png": "1bf2",
	"./logo-10.png": "df4d",
	"./logo-11.png": "8b84",
	"./logo-12.png": "45bd",
	"./logo-13.png": "9e60",
	"./logo-14.png": "a217",
	"./logo-15.png": "a32b",
	"./logo-16.png": "a3e9",
	"./logo-17.png": "2718",
	"./logo-18.png": "8b3a",
	"./logo-19.png": "e8ac",
	"./logo-2.png": "dbe7",
	"./logo-20.png": "a352",
	"./logo-3.png": "a7d2",
	"./logo-4.png": "f9b9",
	"./logo-5.png": "9d09",
	"./logo-6.png": "14ac",
	"./logo-7.png": "6683",
	"./logo-8.png": "fabe",
	"./logo-9.png": "9ca8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e861";